import React, { ReactElement, useMemo } from 'react'
import styles from './Table.module.sass'
import { ColumnProps } from '../Column'
import { SelectFunc } from '../additional'
import clsx from 'clsx'

interface Props<Item> {
    data: Item[],
    children: ReactElement<ColumnProps<Item>>[],
    rowSelector?: SelectFunc<Item>,
    rowFilter?: (item: Item) => boolean,
    rowClass?: (item: Item) => string,
    className?: string,
    withoutHeader?: boolean,
}

export function Table<Item>(props: Props<Item>): JSX.Element {
    const columns: ReactElement<ColumnProps<Item>>[] = useMemo(() => props.children.filter(column => column.props.visible),
        [props.children]
    )

    return <div className={clsx(props.className, styles.table)}>
        <table>
            {
                !props.withoutHeader && <thead>
                <tr>{columns.map((column, index) => <th key={index}>{column.props.headerRenderer}</th>)}</tr>
                </thead>
            }
            <tbody>
            {
                props.data.map((item, row) => <tr key={row} className={props.rowClass?.(item)}>
                    {
                        columns.map((column, col) => <td key={col}>
                            {
                                column.props.cellRenderer?.(item, col, row)
                            }
                        </td>)
                    }
                </tr>)
            }
            </tbody>
        </table>
    </div>
}
